export default __webpack_public_path__ + "static/setup-ff0a758f2933c8f784fc21c5dbe8a556.jpeg";